import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { useFormElement } from '../useFormElement';

import { BaseTextarea, type BaseTextareaProps } from './BaseTextarea';

export { type BaseTextareaIcon as TextareaIcon } from './BaseTextarea';

export type TextareaProps<T extends FieldValues, FP extends Path<T>> = Omit<
	BaseTextareaProps,
	'hasError' | 'name' | 'onChange' | 'ref' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

/**
 *
 * @param {TextareaProps} props - The component's props
 * @param {string} label - label to display
 * @param {string} children - use this in case label is not enough
 * @param {string} defaultChecked - initial checked state
 * @param {string} disabled - is the checkbox disabled
 * @param {boolean} isOnError - can be used to activate the on-error style
 * @param {function} onChange - on box click change callback
 */
export function Textarea<T extends FieldValues, FP extends Path<T> = Path<T>>({
	defaultValue,
	name,
	...props
}: TextareaProps<T, FP>) {
	const {
		field,
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue,
		name
	});

	return <BaseTextarea {...field} error={error} {...props} />;
}
